module.exports = __webpack_public_path__ + "static/media/icon5.4c740a9f.svg";